export default __webpack_public_path__ + "static/media/image_Quotas_dark_blue.26799544.svg";